import React from 'react';
import { TextInput } from '@leverege/ui-elements';
function PasswordEditor(props) {
  const {
    attr,
    onChange,
    data
  } = props;
  return /*#__PURE__*/React.createElement(TextInput, {
    type: "password",
    value: attr.get(data),
    onChange: onChange,
    eventData: {
      attribute: attr
    }
  });
}
const type = 'password';
export default {
  type,
  editor: PasswordEditor
};